import * as types from "./types.js"
import * as api from "./api.js"


const searchRequest = (payload) => ({
    type: types.SEARCH_REQUEST,
    payload
})
const searchReceived = (payload) => ({
    type: types.SEARCH_RECEIVED,
    payload
})
const searchError = (e) => ({
    type: types.SEARCH_ERROR,
    payload: e,
    error: true
})
export function search(criteria) {
    return dispatch => {
        dispatch(searchRequest(criteria))
        return api.search(criteria)
        .then(res => {
            if (res.status !== 200) {
                dispatch(searchError(res.statusText))
            } else {
                return res.json()
                .then(result => {
                    if (result.length === 0) {
                        dispatch(searchError("No results"))
                    } else {
                        dispatch(searchReceived(result))
                    }
                })
            }
        })
    }
}

/*
 * GET CV
 * 
 */
const getCVRequest = () => ({
    type: types.GET_CV_REQUEST
})
const getCVReceived = (payload) => ({
    type: types.GET_CV_RECEIVED,
    payload
})
const getCVError = (e) => ({
    type: types.GET_CV_ERROR,
    payload: e,
    error: true
})
export function getCV(ids) {
    return dispatch => {
        dispatch(getCVRequest())
        return api.getCV(ids)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getCVError(res.statusText))
            } else {
                return res.json()
                .then(result => dispatch(getCVReceived(result)))
            }
        })
    }
}

/*
 * GET ANONYM CV
 * 
 */
const getAnonymCVRequest = () => ({
    type: types.GET_ANONYMCV_REQUEST
})
const getAnonymCVReceived = (payload) => ({
    type: types.GET_ANONYMCV_RECEIVED,
    payload
})
const getAnonymCVError = (e) => ({
    type: types.GET_ANONYMCV_ERROR,
    payload: e,
    error: true
})
export function getAnonymCV(ids) {
    return dispatch => {
        dispatch(getAnonymCVRequest())
        return api.getAnonymCV(ids)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getAnonymCVError(res.statusText))
            } else {
                return res.json()
                .then(result => dispatch(getAnonymCVReceived(result)))
            }
        })
    }
}

/*
 * CLEAR (search result)
 * 
 */
export function clear() {
    return dispatch => {
        dispatch({ type: types.CLEAR_SEARCH })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/search/actions.js
 **/